import React, { Fragment, useMemo } from "react";
import OrderRow from "./OrderRow";
import ShipmentBuilderParent from "./ShipmentBuilderParent";
import {
  availableCountries,
  have_product_reference,
  orderRowsFilter,
  possibilityToAssignDeliveryAmount,
} from "../../../../../helpers/OrdersFunctionsGlobal";
import { orderRowFilteredForBulk } from "../../../../../helpers/OrderRowRules";

const OrderRows = ({
  order,
  order_row_type,
  order_cart_rules,
  bulk_shipments,
  handleSelected,
  handleCheck,
  additionalOptions,
  reload_for_bulk_shipments,
  supp_date,
  pickedSupplierId,
}) => {
  const {
    id: order_id,
    id_order,
    order_shop_id,
    order_invoices,
    order_rows,
  } = order;

  const rebuilded_order_rows = useMemo(() => {
    const re_order_rows = orderRowsFilter(order_rows, order_shop_id).map(
      (d) => ({
        ...d,
        childs: order_rows.filter(
          (order_row) =>
            order_row.parent_id == d.id &&
            !have_product_reference(order_row.product_reference)
        ),
      })
    );
    if (order_row_type !== "Extra services") return re_order_rows;

    if (
      !availableCountries(
        order.shipping_address?.country_id,
        order.order_shop.country_id
      )
    )
      return re_order_rows.map((d) => ({
        ...d,
        manual_disabled: true,
      }));
    //
    return orderRowFilteredForBulk(re_order_rows, { supp_date });
  }, [order_row_type, order_rows, reload_for_bulk_shipments]);

  const invoicesTotal = useMemo(() => {
    const o_invoices = [];
    order_invoices.forEach((e) => {
      if (e.identifier == "pre_invoice") return;
      if (e.order_invoice_order_rows?.length > 0) {
        e.order_invoice_order_rows.forEach((fr) => {
          if (o_invoices.includes(fr.order_row_id)) return;
          o_invoices.push(fr.order_row_id);
        });
      }
    });
    return o_invoices;
  }, [order_invoices]);

  return (
    <Fragment>
      {order_row_type == "Extra services" &&
        bulk_shipments &&
        bulk_shipments.map((d, idx) => (
          <ShipmentBuilderParent
            key={`ShipmentBuilderParent_${d.pickup_address_id}_or`}
            pickup_address_id={d.pickup_address_id}
            supplying_ids={d.supplying_ids}
            order_rows={order_rows
              .filter((or) => d.order_row_ids.includes(or.id))
              .map((order_row) => ({
                ...order_row,
                selected: true,
                quantity:
                  order_row.supplyings.find(
                    (supplying) =>
                      d.pickup_address_id ==
                      supplying.supplier.pickup_address_id
                  )?.amount || 0,
                childs: order_rows.filter(
                  ({ parent_id, product_reference }) =>
                    parent_id == order_row.id &&
                    !have_product_reference(product_reference)
                ),
              }))}
            initialServices={order_rows
              .filter((d) => !have_product_reference(d.product_reference))
              .filter((d) => !d.parent_id)
              .filter((d) => +d.quantity > +d.shipments_count)
              .map((d) => ({
                ...d,
                quantity: +d.quantity - +d.shipments_count,
                selected: idx == 0,
              }))}
            order_id={order_id}
            id_order={id_order}
            handleSelected={handleSelected}
            handleCheck={handleCheck}
            additionalOptions={additionalOptions}
            order_cart_rules={order_cart_rules}
            order_inf={{
              idx,
              carrier: order.carrier,
              shipping_address: order.shipping_address,
              billing_address: order.billing_address,
              remark: order.remark,
              cod: order.cod,
              leasing_cod: order.leasing_cod,
              payment_module: order.payment_module,
              total_price: +order.total_price,
              leasing_advance: order.leasing_advance,
              waiting_payments: order.waiting_payments,
              shipments: order.shipments,
              total_shipping_tax_incl:
                idx == 0
                  ? possibilityToAssignDeliveryAmount({
                    shipments: order.shipments,
                    orderInfo: order,
                  }) || 0
                  : 0,
            }}
            pickedSupplierId={pickedSupplierId}
          />
        ))}

      {rebuilded_order_rows.map((or_item) => {
        return (
          <OrderRow
            key={`rebuilded_order_rows_${or_item.id}`}
            {...or_item}
            id_order={id_order}
            invoicesTotal={invoicesTotal}
            handleCheck={handleCheck}
            handleSelected={handleSelected}
            pickedSupplierId={pickedSupplierId}
          />
        );
      })}
      <div
        className={`d-flex justify-content-between small ${invoicesTotal.length == order_rows.length
            ? "text-success"
            : "text-danger"
          }`}
      >
        <span>Invoices</span>
        <span>
          {invoicesTotal.length} / {order_rows.length}
        </span>
      </div>
      <div className="d-flex justify-content-between small">
        <span>Invoices sent: {order.invoices_sent}</span>
      </div>
    </Fragment>
  );
};

export default OrderRows;
